import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import { VirtualRoomRouterStoreSelectors } from '@era/stores';
import * as fromLocation from './locations.reducer';

export interface State {
  locations: fromLocation.LocationState;
}

export const reducers: ActionReducerMap<State> = {
  locations: fromLocation.locationReducer,
};

export const selectLocationState = createFeatureSelector<fromLocation.LocationState>(
  fromLocation.inRoomLocationsFeatureKey
);

export const selectLocationIds = createSelector(selectLocationState, fromLocation.selectLocationIds);

export const selectLocationEntities = createSelector(selectLocationState, fromLocation.selectLocationEntities);

export const selectAllLocations = createSelector(selectLocationState, fromLocation.selectAllLocations);

export const selectLocationTotal = createSelector(selectLocationState, fromLocation.selectLocationTotal);

export const selectCurrentLocation = createSelector(
  selectLocationEntities,
  VirtualRoomRouterStoreSelectors.selectLocation,
  (locationEntities, location: string) => locationEntities[location]
);
